export const compactObject = <T>(object: T): T => {
  const clonedObject = { ...object };
  for (const key in clonedObject) {
    if (!object[key]) delete clonedObject[key];
  }
  return clonedObject;
};

const compact = <T>(array: (T | undefined | null)[] | undefined): T[] => {
  return (array?.filter(Boolean) as T[]) ?? [];
};

export default compact;
